import type { FilmPick } from "./chapters";

export const filmPicks: FilmPick[] = [
  {
    id: "in-the-mood-for-love",
    title: "花样年华",
    year: 2000,
    region: "中国香港",
    genre: "剧情 / 爱情",
    rating: "8.8",
    reason: "同样把情感藏在旗袍、走廊与雨声里，克制的表达比直白更动人。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20composition%20with%20elegant%20red%20cheongsam%20fabric%20draped%20on%20a%20vintage%20chair%2C%20deep%20crimson%20and%20amber%20light%2C%20narrow%20corridor%20shadow%2C%20melancholic%20film%20noir%20texture%2C%20editorial%20poster%20style%2C%20no%20text&width=700&height=1000&seq=sj-film-01&orientation=portrait",
  },
  {
    id: "crouching-tiger",
    title: "卧虎藏龙",
    year: 2000,
    region: "中国 / 美国",
    genre: "武侠 / 剧情",
    rating: "8.6",
    reason: "同样由李安执导，把江湖的克制与情欲的暗涌放在同一套东方美学里。",
    cover:
      "https://readdy.ai/api/search-image?query=misty%20bamboo%20forest%20at%20dawn%20with%20a%20single%20silhouette%20of%20a%20sword%2C%20muted%20emerald%20and%20warm%20gold%20haze%2C%20minimal%20eastern%20cinematic%20poster%20composition%2C%20ink%20wash%20texture%2C%20no%20text&width=700&height=1000&seq=sj-film-02&orientation=portrait",
  },
  {
    id: "farewell-my-concubine",
    title: "霸王别姬",
    year: 1993,
    region: "中国",
    genre: "剧情 / 年代",
    rating: "9.3",
    reason: "舞台与人生互相吞噬，和本片一样在“扮演”这个命题上走得更远。",
    cover:
      "https://readdy.ai/api/search-image?query=theatrical%20peking%20opera%20headdress%20and%20crimson%20silk%20costume%20details%20under%20dramatic%20stage%20light%2C%20deep%20red%20and%20antique%20gold%20palette%2C%20rich%20cinematic%20still%20life%2C%20no%20text&width=700&height=1000&seq=sj-film-03&orientation=portrait",
  },
  {
    id: "2046",
    title: "2046",
    year: 2004,
    region: "中国香港",
    genre: "剧情 / 爱情",
    rating: "8.1",
    reason: "记忆、房间与反复出现的女人，把暧昧拍成了一种时代情绪。",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20hotel%20corridor%20with%20numbered%20doors%20and%20a%20single%20warm%20lamp%2C%20deep%20burgundy%20walls%2C%20dreamy%20double%20exposure%20cinematic%20texture%2C%20nostalgic%20film%20poster%20mood%2C%20no%20text&width=700&height=1000&seq=sj-film-04&orientation=portrait",
  },
  {
    id: "yiyi",
    title: "一一",
    year: 2000,
    region: "中国台湾",
    genre: "剧情 / 家庭",
    rating: "8.9",
    reason: "以极其冷静的视角看人生各阶段，适合喜欢慢节奏与余味的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20city%20window%20at%20dusk%20reflecting%20warm%20apartment%20lights%2C%20soft%20rain%20on%20glass%2C%20muted%20amber%20and%20charcoal%20palette%2C%20minimal%20melancholic%20cinematic%20composition%2C%20no%20text&width=700&height=1000&seq=sj-film-05&orientation=portrait",
  },
  {
    id: "brokeback-mountain",
    title: "断背山",
    year: 2005,
    region: "美国",
    genre: "剧情 / 爱情",
    rating: "8.7",
    reason: "把无法说出口的感情压缩进山野与沉默，克制得让人心疼。",
    cover:
      "https://readdy.ai/api/search-image?query=wide%20mountain%20landscape%20at%20blue%20hour%20with%20a%20lonely%20wooden%20cabin%20and%20warm%20lantern%20light%2C%20muted%20olive%20and%20amber%20tones%2C%20quiet%20cinematic%20poster%20composition%2C%20no%20text&width=700&height=1000&seq=sj-film-06&orientation=portrait",
  },
];